import React, { useState } from "react";
import TodayVerse from "./TodayVerse";
import { AiOutlineArrowRight, AiOutlineClose } from "react-icons/ai";
import Heading from "./Heading";
import { useFirebaseData } from "../../hooks/useFirebaseData";
import primary from '../../Assets/images/2&5 kanombe.jpg';
import bible2 from '../../Assets/images/CGFK_primary.png';
import bible3 from '../../Assets/images/ESK_logo.png';
import bible4 from '../../Assets/images/FSK_logo.png';
import bible5 from '../../Assets/images/CGFB_logo.png';
import bible6 from '../../Assets/images/Discipleship for Development(D4D).png';
import postal from '../../Assets/images/CGFK_logo.png';
import secondary from '../../Assets/images/secondary.jpeg';
import faet from '../../Assets/images/Forward Africa Education Trust_image.png';
import hipp from '../../Assets/images/HIPP_Image.png';
import peacebuilding from '../../Assets/images/IMG_4487.PNG';
import fph from '../../Assets/images/IMG_4489.PNG';
import compassion from '../../Assets/images/IMG_4764.JPG';
import d4dStory from '../../Assets/D4D Background and Growth Story.docx.pdf';

const categoryImages = {
  pastoral: bible6,
  secondary: secondary,
  primary: primary,
  nursery: bible2,
  esk: bible3,
  fsk: bible4,
  cgfb: bible5,
  cgfk: postal,
  faet: faet,
  hipp: hipp,
  peacebuilding: peacebuilding,
  fph: fph,
  compassion: compassion
};

// Logos that need breathing room instead of being cropped to fill the frame
const containedImageCategories = ['compassion'];

const imageClasses = (category, baseClasses) =>
  containedImageCategories.includes(category)
    ? `${baseClasses} object-contain bg-white p-6`
    : `${baseClasses} object-cover`;

// Programme items that are part of the site itself rather than editable posts
const staticBlogItems = [
  {
    id: 'compassion-international',
    category: 'compassion',
    title: 'Projects Supported by Compassion International',
    website: 'https://www.compassion.com',
    description:
      'Compassion International partners with local churches to run holistic development programs that help children and families escape poverty.',
    content: `Mission and vision
Compassion International shares the hope of the gospel in word and action, releasing children from poverty in Jesus' name.

Who they are
Compassion International is a leading Christian child development organization dedicated to releasing children from spiritual, economic, social, and physical poverty.

Core programs and support
• Child Development Centers: Children go to local centers for after-school tutoring, meals, health checkups, and mentoring.
• Survival Program: Staff visit pregnant mothers and infants at home to provide health monitoring, nutrition advice, and supplies.
• Education Assistance: Projects pay for school fees, uniforms, books, and supplies so children can attend formal school.
• Family and Community Training: Parents learn vocational skills, financial management, and farming or business strategies to earn an independent income.
• Health and Safety: Centers provide clean water, mosquito nets, hygiene stations, and medical care when children get sick.
• Disaster Relief: During emergencies, pandemics, or natural disasters, local teams deliver emergency food, clean water, and shelter.

Our Compassion branches and their districts
• Gafumba — Burera District
• Butaro — Burera District
• Kidaho — Burera District
• Burera — Burera District
• Karangiro — Rusizi District
• Katarara — Bugesera District
• Gasutamo — Rubavu District`
  }
];

// Categories whose "Read more" opens a document instead of plain text
const categoryDocuments = {
  pastoral: d4dStory
};

// Blog Modal Component
const BlogModal = ({ isOpen, onClose, blogItem }) => {
  if (!isOpen || !blogItem) return null;

  const documentUrl = categoryDocuments[blogItem.category];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="relative">
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-10 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100 transition-colors"
          >
            <AiOutlineClose className="text-gray-600 text-xl" />
          </button>
          
          {/* Blog image */}
          <div className="relative">
            <img
              className={imageClasses(blogItem.category, 'w-full h-64 rounded-t-lg')}
              src={categoryImages[blogItem.category] || bible2}
              alt={blogItem.title}
            />
          </div>
          
          {/* Blog content */}
          <div className="p-6">
            <div className="mb-4">
              <span className="inline-block bg-[#ffd615] text-white px-3 py-1 rounded-full text-sm font-medium">
                {blogItem.category?.toUpperCase() || 'EDUCATION'}
              </span>
            </div>
            
            <h2 className="text-3xl font-bold text-gray-800 mb-4 font-[roboto]">
              {blogItem.title}
            </h2>
            
            <div className="text-gray-600 leading-relaxed font-[roboto] whitespace-pre-wrap">
              {blogItem.description}
            </div>

            {/* External website, when the item has one */}
            {blogItem.website && (
              <div className="mt-6">
                <a
                  href={blogItem.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-[#ffd615] text-white rounded-full px-5 py-2 font-[roboto] hover:bg-[#e6c200] transition-colors"
                >
                  Visit their website
                </a>
              </div>
            )}

            {/* Full document for categories that have one */}
            {documentUrl && (
              <div className="mt-6 pt-6 border-t border-gray-200">
                <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
                  <h3 className="text-xl font-semibold text-gray-800">Background and Growth Story</h3>
                  <a
                    href={documentUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-[#ffd615] text-white rounded-full px-5 py-2 font-[roboto] hover:bg-[#e6c200] transition-colors"
                  >
                    Open PDF
                  </a>
                </div>
                <iframe
                  src={documentUrl}
                  title={`${blogItem.title} document`}
                  className="w-full h-[70vh] border border-gray-200 rounded"
                />
              </div>
            )}

            {/* Additional details if available */}
            {blogItem.content && (
              <div className="mt-6 pt-6 border-t border-gray-200">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">More details</h3>
                <div className="text-gray-600 leading-relaxed font-[roboto] whitespace-pre-wrap">
                  {blogItem.content}
                </div>
              </div>
            )}
            
            {/* Date if available */}
            {blogItem.date && (
              <div className="mt-6 pt-4 border-t border-gray-200">
                <p className="text-sm text-gray-500">
                  Published: {new Date(blogItem.date).toLocaleDateString()}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default function Blog() {
  const { data: blogData, loading } = useFirebaseData('blog');
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Keep the static items out of the list once the same category exists in Firebase
  const items = [
    ...blogData,
    ...staticBlogItems.filter(
      (staticItem) => !blogData.some((item) => item.category === staticItem.category)
    )
  ];

  const handleReadMore = (blogItem) => {
    setSelectedBlog(blogItem);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedBlog(null);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div id="blog">
      <TodayVerse />
      <div className="bg-gray-50 w-full">
        <div className="max-w-6xl mx-auto">
          <Heading 
            title="E D U C A T I O N" 
            subtitle="Education" 
            description="As the Eglise Evangelique des Amis au Rwanda (EEAR)/Eglise Evangelique Des Amis au Rwanda we are dedicated to serving God as well as the people of God, in this spirit we commit ourselves to generate hope through educating Rwandans in general. We have many schools with excellent standards (nursery, primary, secondary) Schools and one pastoral Training College."
          />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 px-6">
            {items.map((item) => (
              <div key={item.id}>
                <div className="flex relative text-[#fbcf00]">
                  <img
                    className={imageClasses(item.category, 'w-full h-96')}
                    src={categoryImages[item.category] || bible2}
                    alt={item.title}
                  />
                </div>
                <div className="text-[25px] font-[roboto] py-2 text-center">
                  {item.title}
                </div>
                <div className="text-[#4c4c4c] font-[roboto] text-center line-clamp-2 overflow-hidden">
                  {item.description}
                </div>
                <div className="px-4 text-center my-10">
                  <button 
                    className="bg-[#ffd615] text-white rounded-full px-5 py-2 hover:bg-[#e6c200] transition-colors"
                    onClick={() => handleReadMore(item)}
                  >
                    <div className="flex gap-2 font-[roboto]">
                      <div>Read more</div>
                      <div className="mt-1">
                        <AiOutlineArrowRight />
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* Blog Modal */}
      <BlogModal 
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        blogItem={selectedBlog}
      />
    </div>
  );
}
